import React from 'react'
import { Form } from 'react-bootstrap'
import HeaderData from '../Form/HeaderData.jsx'
import PositionList from '../Form/PositionList.jsx'
import { useLocalReceiptDataState } from '../../../stores/LocalReceiptDataProvider.js'

const CreateReceiptContentArea = () => {
  const {
    formErrors,
    headerData,
    setHeaderDataByKey,
    resetErrorByFormKey,
    positions,
    addPosition,
    copyPosition,
    splitPosition,
    setPositions,
    actionMode
  } = useLocalReceiptDataState()
  return (
    <Form>
      <HeaderData actionMode={actionMode} headerData={headerData} setHeaderDataByKey={setHeaderDataByKey} formErrors={formErrors} resetErrorByFormKey={resetErrorByFormKey} />
      <PositionList actionMode={actionMode} addPosition={addPosition} copyPosition={copyPosition} splitPosition={splitPosition} positions={positions} setPositions={setPositions} formErrors={formErrors} resetErrorByFormKey={resetErrorByFormKey} />
    </Form>
  )
}

export default CreateReceiptContentArea

